import React, { Component } from 'react';
import { Row, Col, Card, Container,Form,Button } from 'react-bootstrap';
import { components } from 'react-select'
import * as Cookies from "es-cookie";
import '../_quiz.scss';
import SelectBoxWithDisabledOption from '../../selectdropdown/SelectBoxWithDisabledOption';
import { Link, withRouter } from 'react-router-dom';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import parse, { domToReact } from 'html-react-parser';
import { Scrollbars } from 'react-custom-scrollbars'
import InfiniteScroll from 'react-infinite-scroll-component';
import { scroller } from "react-scroll";
import QuizModal from '../QuizModal';
import moment from 'moment';
import MultiSelect from "react-multi-select-component";

const GROUPcreateQuizPaper = gql`
  mutation(
    $params:GroupCustomPaper,
    $time_duration:Int,
    $question_count:[SubjectQuestionCount],
    $examPaperId: Int 
    ) {
        createQuizPaper(
        params: $params,
        time_duration: $time_duration,
        question_count: $question_count,
        examPaperId: $examPaperId
     ){
         filename
        exam_paper_id
        exam_questions{
            id
            subject
            chapter
            question
            option1
            option2
            option3
            option4
            qtype
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
            chapter_name
        }
     }
  }
`;

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class EditQuizSection extends Component {
    constructor(props) {
        super(props)

        let classData = '',viewType="";
        if(props.location.state?.examDetails?.class_id == 1){
            classData = {
                value: 1,
                label: "XI"
            }
        } else{
            classData = {
                value: 2,
                label: "XII"
            }
        }
        if(props.location.state?.examDetails?.time_duration == 15 ){
            viewType="6Questions"
        }else{
            viewType="15Questions"
        }

        this.state = {
            qbsearchExamType: "0",
            qbsearchExamTypevalue: "",
            qbsearchsubject: "0",
            qbsearchsubjectvalue: "",
            qbsearchchapter: "0",
            qbsearchchaptervalue: "",
            subjects: [],
            owedqfilterclass: "1",
            getInstituteQuestions:"",
            validateSubject:"",
            validateChapter:"",
            questionsLoading:"",
            showSpinner:"hide",
            viewType:viewType,
            validateQuestionSelected:[],
            checkedVall:false,
            exam_name:"",
            submitError1: "",
            buttonstatus: "",
            startdate: props.location.state?.examDetails?.start_time,
            enddate: "",
            modalShow: false,
            modalShowTwo: false,
            currentStep: 1,
            exam_name: props.location.state?.editType == "draft" ? props.location.state?.examDetails?.name : props.location.state?.examDetails?.exam_name,
            class:props.location.state?.examDetails?.class,
            classvalue: classData,
            section: "",
            sectionvalue: "",
            branch: "",
            timeduration:0,
            subjectOptions:[],
            validationMessage:"",
            qbsearchtopic: "0",
            qbsearchtopicvalue: "",
            validateTopic:"",
            questionSelectedMessage:"",
            examPaperId:parseInt(props.location.state?.examDetails?.id),
            examTypeOptions:[],
            getSectionsArr:[],
            qbquestiontypes: [],
            qbquestiontypesvalue: [],
            getChaptersArr:[],
            getTopicsArr:[],
            hasMore: true,
            page:1
        }
    }

    
    componentDidMount() {
       
        console.log("sssss",this.props)
        // let examsData = this.props.globals.exams.find((a) => a.id == "1");
         //let examsubjectData = examsData.exam_subjects;
         let examsubjectData = this.props.globals.subjects;
         let subjects = [];
         
         // newcodeend
         for (let i = 0; i <= examsubjectData.length; i++) {
             let idata = examsubjectData[i];
             console.log("idata", idata);
             if (idata != undefined) {
                 let subjectData = this.props.globals.subjects.find((a) => a.id == idata.id);
                 // console.log("subjectData", subjectData);
                 let chapters = subjectData.chapters.map((item) => {
                     console.log("subjectData", subjectData);
                     const topic = item.topics.map((topicData) => {
                         return { ...topicData, checked: false }
                     })
                     const questionbarray = this.props.location.state?.examDetails?.exam_questions.filter((a) => {
                        if(a.chapter == item.id){
                            return a;
                        }
                        else if(a.chapter.indexOf(',') > 1){
                            let arr = a.chapter.split(',');
                            if(arr.indexOf(item.id) == 0){
                                return a;
                            }
                        } 
                    });

                    if(questionbarray.length > 0){
                        return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [...questionbarray] }
                    }
 
                     return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [] }
                 })
            
               
 
                 const newObject = {
                     id: subjectData.id,
                     subject: subjectData.subject,
                     chapters: chapters,
                     checked: false,
                     subjectactive: "d-flex justify-content-between align-items-center",
                     qcount: idata.no_of_questions,
                     totError: ""
 
                 }
                 subjects.push(newObject);
 
 
             }
 
         }
         let examTypeArr=[];
         for (let i = 0; i <= this.props.globals.exams.length; i++) {
             let idata = this.props.globals.exams[i];
             if (idata != undefined) {
                 if(this.props.location.state?.examDetails?.exam_type == idata.id){
                    const newObj = {
                        value: idata.id,
                        label: idata.exam,
                    }
                    
                    examTypeArr.push(newObj);
                 }
                
 
             }
 
         }
 
         console.log("subjects",subjects)
 
         this.setState({
             subjects: subjects,
             examTypeOptions:examTypeArr
         });
     }

     handleSelect(val) {
       
        this.setState({
            viewType: val
           
        });
    }

    getChapters = (chapterId) => {
        let getArray = [];
        for (let i = 0; i <= this.state.subjects.length; i++) {
            let idata = this.state.subjects[i];
            if (idata != undefined) {
                if (idata.id == this.state.qbsearchsubject) {
                    let chData = "";
                    if (this.state.owedqfilterclass != "0") {
                        chData = idata.chapters.filter((a) => a.class == this.state.owedqfilterclass);
                    }
                    else {
                        chData = idata.chapters;
                    }
                    chData.map((chmapData) => {
                        if(chapterId == chmapData.id){
                            const newObj = {
                                value: chmapData.id,
                                label: chmapData.chapter
                            }
                            getArray.push(newObj);
                        }
                        
                    })

                }
            }

        }
        this.setState({
            getChaptersArr: getArray
           
        });
        
        //return getArray;
    }

    getTopics = (topicId) => {
        let getTopicArr = [];
        for (let i = 0; i <= this.state.subjects.length; i++) {
            let idata = this.state.subjects[i];
            if (idata != undefined) {
                if (idata.id == this.state.qbsearchsubject) {
                    idata.chapters.map((chmapData) => {
                        if(chmapData.id == this.state.qbsearchchapter){
                            chmapData.topics.map((topicData) => {
                                if(topicId == topicData.id){
                                    const newObj = {
                                        value: topicData.id,
                                        label: topicData.topic
                                    }
                                    getTopicArr.push(newObj);
                                }
                               
                            })
                        }
                        
                    })

                }
            }

        }
        

        this.setState({
            getTopicsArr: getTopicArr
           
        });

        //return getTopicArr;
    }

   

    OpenQuestions = async (questions)=>{
       this.setState({
         showSpinner: "show",
       });


        let getSelectedsections = this.props.location.state?.examDetails?.section.split(",");
        let sections = this.props.getSections;

        console.log("aaaaaa",this.props.location.state?.editType)
        console.log("aravinddddddd",getSelectedsections)
        console.log("aravinddddddd",sections)

        let qbquestiontypes1 = [];
        let qbquestiontypesvalue1 = [];

        getSelectedsections.map((selsec,index) => {
            if(this.props.location.state?.editType != "draft"){
                sections.filter(a => selsec == a.id).map(item => {
                    const newObj = {
                        label: item.id,
                        value: item.section_name
                    }
                    qbquestiontypesvalue1.push(newObj);
                    qbquestiontypes1.push(item.id);
                })
            }else{
                sections.filter(a => selsec == a.section_name).map(item => {
                    const newObj = {
                        label: item.id,
                        value: item.section_name
                    }
                    qbquestiontypesvalue1.push(newObj);
                    qbquestiontypes1.push(item.id);
                })
            }
           

        })


       

         let array=this.props.location.state?.examDetails?.exam_questions;
         let QuestionSelectedLength=0;
         let remainingQusSel=0;

         console.log("arralen",this.props.location.state?.examDetails?.exam_questions)
         console.log("arralen",array.length)
        if(this.state.viewType == "6Questions"){
            QuestionSelectedLength = 5;
            if(array.length == 6){
                this.setState({validationMessage:"Maximum Questions Reached",validateQuestionSelected:array});
            }else{
                remainingQusSel = QuestionSelectedLength - array.length;
                this.setState({validationMessage:"Please Check Remaining "+remainingQusSel+" Questions ",validateQuestionSelected:array });
            }
            
        }else{
            QuestionSelectedLength = 14;
            if(array.length == 15){
                this.setState({validationMessage:"Maximum Questions Reached",validateQuestionSelected:array });
            }else{
                remainingQusSel = QuestionSelectedLength - array.length;
                this.setState({validationMessage:"Please Check Remaining "+remainingQusSel+" Questions ",validateQuestionSelected:array });
            }
           
        }


        let topicIdArr=[];
        let uniqTopicArr=[];
        questions.questionbarray.map((topic,index) => {
            topicIdArr.push(topic.topic);
        })
       
        uniqTopicArr = [...new Set(topicIdArr)];
        let topicIds = uniqTopicArr.toString();
            topicIds =  topicIds != '' && topicIds.split(',');

        this.getChapters(questions.id);
        this.getTopics(topicIds[0]);

        this.selecthandleInputChange("qbsearchExamType",this.props.location.state?.examDetails?.exam_type);
        this.selecthandleInputChange("qbsearchsubject",questions.subjectId);

        setTimeout(()=>{
            this.selecthandleInputChange("qbsearchchapter",questions.id);
            this.selecthandleInputChange("qbsearchtopic",topicIds[0]);
        },500);

        //qbsearchtopicvalue


        this.setState({
            qbquestiontypesvalue: qbquestiontypesvalue1,
            qbquestiontypes: qbquestiontypes1
        });
        
        

        const result = await this.props.client.query({
            query: gql` 
        query(
            $subject:String!,
            $chapter:String!,
            $topic:String!,
            $question_type:String,
            $question_theory:String,
            $complexity: String,
            $institute_id: Int!,
            $page: Int,
            $type: Int, 
            
            ) {
                getInstituteQuestionsWithTopic(
                    subject: $subject,
                    chapter: $chapter,
                    topic: $topic,
                    question_type: $question_type,
                    question_theory: $question_theory,
                    complexity:$complexity,
                    institute_id: $institute_id,
                    page:$page,
                    type: $type
                )
                {
                    id
                    subject
                    question
                    chapter
                    topic
                    complexity
                    question_theory
                    qtype
                    mat_question
                    compquestion
                    list1type
                    list2type
                    subject_name
                    chapter_name
                    topic_name
                    option1
                    option2
                    option3
                    option4
                    answer
                    usageset
            }
        }
    `,
                variables: {

                    subject: questions.subjectId,
                    chapter: questions.id,
                    topic: uniqTopicArr.toString(),
                    question_type: "7",
                    question_theory: "0",
                    complexity: "0",
                    institute_id: parseInt(Cookies.get("institutionid")),
                    page: 1,
                    type: 1

                },
                fetchPolicy: 'network-only'
            });

            console.log("aaaaa",result);
            setTimeout(() => {
                this.setState({
                    getInstituteQuestions: result.data.getInstituteQuestionsWithTopic,
                    questionsLoading:result.loading,
                    showSpinner: "hide",
                    
                });
            }, 800);

       
    }

    

    onScrollgetQuestionById = async (e) => {

        this.setState({validateSubject:"",validateChapter:"",validateTopic:"",questionsLoading:"",getInstituteQuestions:"",showSpinner:"hide",validationMessage:"" });

        this.setState({
            showSpinner: "show",
          });

          let array=this.props.location.state?.examDetails?.exam_questions;
          let QuestionSelectedLength=0;
          let remainingQusSel=0;
 
          console.log("arralen",this.props.location.state?.examDetails?.exam_questions)
          console.log("arralen",array.length)
         if(this.state.viewType == "6Questions"){
             QuestionSelectedLength = 5;
             if(array.length == 6){
                 this.setState({validationMessage:"Maximum Questions Reached",validateQuestionSelected:array});
             }else{
                 remainingQusSel = QuestionSelectedLength - array.length;
                 this.setState({validationMessage:"Please Check Remaining "+remainingQusSel+" Questions ",validateQuestionSelected:array });
             }
             
         }else{
             QuestionSelectedLength = 14;
             if(array.length == 15){
                 this.setState({validationMessage:"Maximum Questions Reached",validateQuestionSelected:array });
             }else{
                 remainingQusSel = QuestionSelectedLength - array.length;
                 this.setState({validationMessage:"Please Check Remaining "+remainingQusSel+" Questions ",validateQuestionSelected:array });
             }
            
         }

        const result = await this.props.client.query({
            query: gql` 
        query(
            $subject:String!,
            $chapter:String!,
            $topic:String!,
            $question_type:String,
            $question_theory:String,
            $complexity: String,
            $institute_id: Int!,
            $page: Int,
            $type: Int, 
            
            ) {
                getInstituteQuestionsWithTopic(
                    subject: $subject,
                    chapter: $chapter,
                    topic: $topic,
                    question_type: $question_type,
                    question_theory: $question_theory,
                    complexity:$complexity,
                    institute_id: $institute_id,
                    page:$page,
                    type: $type
                )
                {
                    id
                    subject
                    question
                    chapter
                    topic
                    complexity
                    question_theory
                    qtype
                    mat_question
                    compquestion
                    list1type
                    list2type
                    subject_name
                    chapter_name
                    topic_name
                    option1
                    option2
                    option3
                    option4
                    answer
                    usageset
            }
        }
    `,
                variables: {

                    subject: this.state.qbsearchsubject,
                    chapter: this.state.qbsearchchapter,
                    topic: this.state.qbsearchtopic,
                    question_type: "7",
                    question_theory: "0",
                    complexity: "0",
                    institute_id: parseInt(Cookies.get("institutionid")),
                    page: 1,
                    type: 1

                },
                fetchPolicy: 'network-only'
            });

            console.log("aaaaa",result);
            setTimeout(() => {
                this.setState({
                    getInstituteQuestions: result.data.getInstituteQuestionsWithTopic,
                    questionsLoading:result.loading,
                    showSpinner: "hide"
                });
            }, 800);
       
    }

    onScrollgetQuestions = async (e, dactive) => {
        //let totallenth = this.state.getInstituteQuestions.length;

        console.log("ssssssssssssssssssssssssssss",this.state.getInstituteQuestions.length)
        console.log("hasMorehasMorehasMorehasMorehasMore",this.state.hasMore)
        if (this.state.getInstituteQuestions.length < 10) {
            this.setState({ hasMore: false });
        }
        else {

            let page = parseInt(this.state.page) + 1;
            this.setState({
                page: page
            });
            console.log("variables:", {
                subject: this.state.qbsearchsubject,
                chapter: this.state.qbsearchchapter,
                topic: this.state.qbsearchtopic,
                question_type: "7",
                question_theory: "0",
                complexity: "0",
                institute_id: parseInt(Cookies.get("institutionid")),
                page: parseInt(page),
                type: 1
            });

            const result = await this.props.client.query({
                query: gql` 
        query(
            $subject:String!,
            $chapter:String!,
            $topic:String!,
            $question_type:String,
            $question_theory:String,
            $complexity: String,
            $institute_id: Int!,
            $page: Int,
            $type: Int, 
            
            ) {
                getInstituteQuestionsWithTopic(
                    subject: $subject,
                    chapter: $chapter,
                    topic:$topic,
                    question_type: $question_type,
                    question_theory: $question_theory,
                    complexity:$complexity,
                    institute_id: $institute_id,
                    page:$page,
                    type: $type
                )
                {
                    id
                    subject
                    question
                    chapter
                    topic
                    complexity
                    question_theory
                    qtype
                    mat_question
                    compquestion
                    list1type
                    list2type
                    subject_name
                    chapter_name
                    topic_name
                    option1
                    option2
                    option3
                    option4
                    answer
                    usageset
            }
        }
    `,
                variables: {

                    subject: this.state.qbsearchsubject,
                    chapter: this.state.qbsearchchapter,
                    topic: this.state.qbsearchtopic,
                    question_type: "7",
                    question_theory: "0",
                    complexity: "0",
                    institute_id: parseInt(Cookies.get("institutionid")),
                    page: parseInt(page),
                    type: 1

                },
            })
            console.log("result.data.getInstituteQuestions", result.data.getInstituteQuestionsWithTopic);

            if (result.data.getInstituteQuestionsWithTopic.length == 0) {
                this.setState({ hasMore: false, page: page });
                return;
            }
            else {
                setTimeout(() => {
                    this.setState({
                        page: page,
                        getInstituteQuestions: this.state.getInstituteQuestions.concat(result.data.getInstituteQuestionsWithTopic)
                    });
                }, 2000);
            }


        }

    }

    handleMultipleSelectInputChange = (e, name) => {
        console.log("handleMultipleSelectInputChange", e, name);
        if (name == "qbquestiontypes") {
            let qbquestiontypes = Array();
            let qbquestiontypesvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbquestiontypesval = e[i];
                    const newObj = {
                        label: qbquestiontypesval.label,
                        value: qbquestiontypesval.value
                    }
                    qbquestiontypesvalue.push(newObj);
                    qbquestiontypes.push(qbquestiontypesval.value);
                }
                this.setState({
                    qbquestiontypesvalue: qbquestiontypesvalue,
                    qbquestiontypes: qbquestiontypes
                });
            }
        }
       
    }

    selecthandleInputChange = async(ename, evalue) => {
       
        console.log("selecthandleInputChange", this.props.globals.globalSections);
        const name = ename;
        const value = evalue;
       
        if (name == "qbsearchsubject") {
           
            let subjectData = this.state.subjects.find((a) => a.id == value);
            console.log("sssssssss",subjectData)
            this.setState({
                qbsearchsubjectvalue: {
                    value: subjectData.id,
                    label: subjectData.subject
                },
                qbsearchchapter: "",
                qbsearchchaptervalue: ""
            });
        }
       
        if (name == "qbsearchchapter") {
            let subjectData = this.state.subjects.find((a) => a.id == this.state.qbsearchsubject);
            let chData = subjectData.chapters.find((a) => a.id == value);


            this.setState({
                qbsearchchaptervalue: {
                    value: chData.id,
                    label: chData.chapter
                }
            });
        }
        if (name == "qbsearchtopic") {
            let subjectData = this.state.subjects.find((a) => a.id == this.state.qbsearchsubject);
            let chData = subjectData.chapters.find((a) => a.id == this.state.qbsearchchapter);
            let topicData = chData.topics.find((a) => a.id == value);

            this.setState({
                qbsearchtopicvalue: {
                    value: topicData.id,
                    label: topicData.topic
                }
            });
        }
        if (name == "class") {
            let classData = this.state.subjects.find((a) => a.id == value);
            this.setState({
                classvalue: {
                    value: classData.id,
                    label: classData.class
                }
            });
        }
        if (name == "section") {
            let sectionsData = this.props.getSections.find((a) => a.id == value);
            this.setState({
                sectionvalue: {
                    value: sectionsData.id,
                    label: sectionsData.section_name
                }
            });
            
            this.setState({
                branch: sectionsData.branch_id
            });
        }
        if (name == "qbsearchExamType") {

            let examsData = this.props.globals.exams.find((a) => a.id == value);
            this.setState({
                 qbsearchExamTypevalue: {
                     value: examsData.id,
                     label: examsData.exam
                 }
             });
           
 
             let getArray1 = [],sectionsArr = [];
             for (let i = 0; i <= this.props.globals.subjects.length; i++) {
                 let idata = this.props.globals.subjects[i];
                 if (idata != undefined) {
                     if(value == idata.id){
                        console.log("aravind",value)
                        if(value == 1 || value == 7){
                            if(idata.id !=4){
                                const newObj = {
                                    value: idata.id,
                                    label: idata.subject,
                                }
                                getArray1.push(newObj);
                            }
                            
                        }else if(value == 3 || value == 2){
                            console.log("aravind",value)
                            if(idata.id ==2 || idata.id ==3 || idata.id ==4){
                                const newObj = {
                                    value: idata.id,
                                    label: idata.subject,
                                }
                                getArray1.push(newObj);
                            }
                            
                        }else{
                            const newObj = {
                                value: idata.id,
                                label: idata.subject,
                            }
                            getArray1.push(newObj);
                        }
                     }
                     
                 }
     
             }
             for (let i = 0; i <= this.props.globals.globalSections.length; i++) {
                 let idata = this.props.globals.globalSections[i];
                 if (idata != undefined) {
                     if(this.props.location.state?.examDetails?.exam_type == idata.exam_id){
                         console.log("aravindwwwwwwwwwwww","yessss")
                         const newObj = {
                             value: idata.id,
                             label: idata.section_name
                         }
                         sectionsArr.push(newObj);
                     }
                 }
             }
 
             this.setState({
                 subjectOptions:getArray1,
                 getSectionsArr:sectionsArr
             });
            
             
         }
        
       
        this.setState({ [name]: value });
    }

    

     getDraftQuestions = ()=>{
        let array2 = [];
        this.state.subjects.map((item) => {
            item.chapters.map((chdata) => {
                console.log("aravind",chdata)
                // const questionbarray = this.props.examDetails.exam_questions.filter((a) => a.chapter == chdata.id);
                // if(questionbarray.length > 0){
                //     if(chdata.questionbarray.length > 0){
                //         chdata.questionbarray.push(questionbarray);
                //         let object = { ...chdata ,subjectId :item.id};
                //         array1.push(object);
                //     } else {
                //         let object = { ...chdata, questionbarray: questionbarray ,subjectId :item.id};
                //         array1.push(object);
                //     }
                //     return { ...chdata, questionbarray: questionbarray };
                // } else 
                if(chdata.questionbarray.length > 0){
                    
                    let object = { ...chdata ,subjectId :item.id,subjectName :item.subject};
                    array2.push(object);
                }
            });
        });
        console.log("aravind",array2)
        return array2;
    }
 
    idFunction(data) {
        let id = parseInt(data + 1);
        return id;
    }

    QuestionFunction = (e, questionsdata, type) => {
        this.setState({questionSelectedMessage: "",validationMessage:""});
        
        let subjectArray = [];
        let QuestionSelectedLength=0;
        if(this.state.viewType == "6Questions"){
            QuestionSelectedLength = 5
        }else{
            QuestionSelectedLength = 14
        }
        if (type == "qbank") {
            if (e?.target?.checked == true) {
               
                if(this.state.validateQuestionSelected.length > QuestionSelectedLength){
                    scroller.scrollTo("your_css_class_here", {
                        duration: 800,
                        delay: 0,
                        smooth: "easeInOutQuart",
                    });
                    this.setState({checked: !this.state.checkedVall,validationMessage:"Maximum Questions Reached"});
                    return;
                }

                this.state.validateQuestionSelected.push(questionsdata);
            }else{
                for( var i in this.state.validateQuestionSelected){ 
                    if ( this.state.validateQuestionSelected[i].id == questionsdata.id) { 
                        this.state.validateQuestionSelected.splice(i, 1);
                        this.setState({validateQuestionSelected: this.state.validateQuestionSelected}); 
                    }
                
                }
            }
            
            subjectArray = this.state.subjects.map((subjectData) => {
                if (subjectData.id == this.state.qbsearchsubject) {
                    const chData = subjectData.chapters.map((chmapData) => {
                        if (chmapData.id == this.state.qbsearchchapter) {
                            if (e.target.checked == true) {
                                let array = chmapData.questionbarray;
                                array.push({ ...questionsdata });
                                return { ...chmapData, questionbarray: array }
                               
                            }
                            else {
                                const questionbarray = chmapData.questionbarray.filter((a) => a.id != questionsdata.id);
                                //questionbarray.push(questionsdata);
                                return { ...chmapData, questionbarray: questionbarray }
                            }
                        }
                        return { ...chmapData }

                    })
                    return { ...subjectData, chapters: chData }
                }
                return { ...subjectData }
            });
        }    
        

        this.setState({ subjects: subjectArray });

    }

    getSelectedSubject = () =>{
        let subjectName='';
        if(this.state.qbsearchsubject == "1"){
            subjectName = "Botany"
        }else if(this.state.qbsearchsubject == "2"){
            subjectName = "Physics"
        }else if(this.state.qbsearchsubject == "3"){
            subjectName = "Chemistry"
        }else if(this.state.qbsearchsubject == "4"){
            subjectName = "Mathematics"
        }else if(this.state.qbsearchsubject == "5"){
            subjectName = "Zoology"
        }

        return subjectName;
    }


    sheduleFunction = (e) => {
        this.setState({ isonline: "1" });
        this.setState({
            submitError: "",
            buttonstatus: "shedule"
        });
    }

    datefunction = (moment, name) => {
        console.log("datefunction", moment._d, name);
        let date = String(moment._d);
        var res = date.substr(4, 20);
        console.log("res", res);
        this.setState({ startdate: res });

        this.setState({
            submitError1: ""
        });
    }
    datefunctionend = (moment, name) => {
        console.log("datefunction", moment._d, name);
        let date = String(moment._d);
        var res = date.substr(4, 20);
        console.log("res", res);
        this.setState({ enddate: res });

        this.setState({
            submitError1: ""
        });
    }

    handleInputChange = (e) => {
        console.log("handleInputChange", e.target.name, e.target.checked)
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });

    }

    handleFormSubmit = (e,type) => {
       

        e.preventDefault();
        
        this.setState({
            spinnerStatus: "1"
        });
        setTimeout(() => {
            console.log("Form submitted",this.state);
            console.log("aravind",this.props)
        let stateSyllabus = this.state.subjects;
        let syllabusArray = [];
        let qbankQuestion = [];
        let ownedQuestion = [];
        let selectedSubjectId=[];
        let topicArray = [];
        let is_draft=0;
        let sectionsArr=[];
        for (let i = 0; i < stateSyllabus.length; i++) {

            let idata = stateSyllabus[i];
            console.log("idata", idata);
            let totalchapters = idata.chapters;
            for (let x = 0; x < totalchapters.length; x++) {
                let tdata = totalchapters[x];
                
                if (tdata.questionbarray.length > 0) {
                    tdata.questionbarray.map((questionbarraymapData) => {
                        const newquestionId = questionbarraymapData;
                        qbankQuestion.push(parseInt(newquestionId.id));
                    })

                }

                let totaltopics = tdata.topics;

                for (let y = 0; y < totaltopics.length; y++) {
                    let ttdata = totaltopics[y];
                    console.log("ttdata", ttdata);
                    if (ttdata.checked == true) {
                        let newtopic = ttdata.id;
                        console.log("newtopic", newtopic);
                        topicArray.push(newtopic);

                    }
                }

            }

            console.log("topicArray", topicArray);
            const newSyllabus = {
                subject_id: parseInt(idata.id),
                chapters: [],
                topics: topicArray
            }
            syllabusArray.push(newSyllabus);

           
          
            if(this.state.qbsearchsubject == idata.id){
                selectedSubjectId.push(parseInt(idata.id));
               
            }

        }

        let newArray = syllabusArray.filter(item =>
            item.topics.length > 0
        )

        let startdate = "";
        let enddate = "";
        if(this.state.startdate != ""){
            is_draft=0;
            if (this.state.startdate == "") {

                startdate = moment().unix();
                //moment().format("DD-MM-YYYY @ HH:mm:ss");
            }
            else {
                startdate = moment(this.state.startdate, "MMM DD YYYY HH:mm:ss").unix();
            }
    
        }else{
            is_draft=1;
            startdate = moment().unix();
            
        }

        if( Cookies.get("institutionid") == 19){
                enddate = moment(this.state.enddate, "MMM DD YYYY HH:mm:ss").unix();
        }else{
                enddate = "";
        }
        
        for (let i = 0; i < this.state.qbquestiontypes.length; i++) {
            sectionsArr.push(parseInt(this.state.qbquestiontypes[i]));
        }
        
        if(this.state.viewType == "6Questions"){
            this.state.timeduration = 15
        }else{
            this.state.timeduration = 30
        }

        let creategeneralpaper = "";
        creategeneralpaper = {
            exam_name: this.state.exam_name,
            class_id: parseInt(this.state.class),
            branch:this.state.branch.toString(),
            section: sectionsArr.toString(),
            start_time: startdate.toString(),
            end_time:enddate.toString(),
            institution_id: parseInt(Cookies.get("institutionid")),
            username: Cookies.get("username"),
            questionbank_questions: qbankQuestion.toString(),
            institution_questions:ownedQuestion.toString(),
            no_of_sets: 1,
            question_type:selectedSubjectId.toString(),
            is_draft:is_draft
        }
        console.log("paper",creategeneralpaper);
        const question_count = this.state.subjects.map((a) => {
            return {
                subject_id: parseInt(a.id),
                question_count: parseInt(this.state.validateQuestionSelected.length)
            }
        });
        console.log('creategeneralpaper', creategeneralpaper,
            parseInt(this.state.timeduration),
            question_count);

        this.creategroupgeneralpaperfun(
            creategeneralpaper,
            parseInt(this.state.timeduration),
            question_count,
            this.state.examPaperId
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError1: error.graphQLErrors.map(x => x.message), spinnerStatus: ""
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
    }, 1000);
    };

    creategroupgeneralpaperfun = async (
        params,
        time_duration,
        question_count,
        examPaperId
    ) => {
        await this.props.creategroupgeneralpaperfun({
            variables: {
                params,
                time_duration,
                question_count,
                examPaperId
            },
            update: (store, { data }) => {
                console.log("createGeneralPaperdata", data);
                if (data.createQuizPaper) { 
                    
                    this.setState({
                        currentStep: 5,
                        submitError1: "",
                        filename: data.createQuizPaper.filename,
                    });
                    

                    setTimeout(() => {
                        this.props.history.push({
                            pathname: "/quiz_section",
                        });
                    }, 2000);
                    
                    
                }
            }
        });
    };

    popupModalQuiz = (e) => {
        let QuestionSelectedLength=0;
        if(this.state.viewType == "6Questions"){
            QuestionSelectedLength = 5
        }else{
            QuestionSelectedLength = 14
        }

        if(this.state.validateQuestionSelected.length < QuestionSelectedLength){
            let remainingQusSel=0;
            remainingQusSel = (QuestionSelectedLength - this.state.validateQuestionSelected.length)+1;
            if(this.state.viewType == "6Questions"){
                this.setState({questionSelectedMessage:"Please Check Remaining "+remainingQusSel+" Questions " });
            }else{
                this.setState({questionSelectedMessage:"Please Check Remaining "+remainingQusSel+" Questions " });
            }
            
            return;
        }else{
            this.setState({ modalShow: true, submitError1: "" })
        }
        
    }

    render() {
        console.log("aravindddddddee",this.state);
        let subjectData = this.props.globals.subjects;
        

        let finddata = [];
        let newData1=[];
        let latestData=[];
        

       if(this.state.getInstituteQuestions != ""){
        this.state.getInstituteQuestions.map((item) => {
            this.state.subjects.map((item1) => {
                if (parseInt(item1.id) == parseInt(item.subject)) {
                    item1.chapters.map((item3) => {

                        const arr = item.chapter;
                        console.log("sssss",arr)
                        if (arr.includes(item3.id.toString())) {
                            if(item3.questionbarray.length > 0){
                                finddata = item3.questionbarray
                                console.log("find",finddata);
                            }
                        }
                        
                    })
                }
            })
        });

        console.log("finddatafinddatafinddatafinddata",finddata)

       
        if(finddata.length>0){
            newData1 = this.state.getInstituteQuestions.map((item) => {
           
                if (finddata.length > 0) {
                    console.log("item",item)
                    
    
                    if (finddata.find((a) => a.id == item.id)) {
                          return { ...item, checked: true }
                    }
                    else {
                        return { ...item, checked: false }
                    }
                }
                
            
        })
        }
        
        if(newData1.length>0){
                latestData = newData1.filter((a) => a.id.includes(this.state.qbsearchsubject));
        }else{
                //latestData = this.state.getInstituteQuestions;
                //latestData = this.state.getInstituteQuestions;
                latestData = this.state.getInstituteQuestions.filter((a) => a.id.includes(this.state.qbsearchsubject));
        }
        console.log("this.state.generalCheckedgeneralChecked", this.state);


      

       }

        return (
            <div className='quiz_section your_css_class_here'>
                <Container fluid>
                    <Row>
                        <Col sm={12}>
                            <Card as={Card.Body} className="">
                                <h3 className='text-center'>Edit Quiz </h3>


                                <h5>Quiz Name : {this.state.exam_name}</h5>

                                <h5 className='mt-3'>Summary</h5>
                                <div className="table-responsive mt-2">
                                    <table className="table table-bordered table_custom_cls">
                                        <thead>
                                            <tr>
                                                <th>Subject</th>
                                                <th>Chapter</th>
                                                <th>Topics</th>
                                                <th>No.Of.Question Selected</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.getDraftQuestions().map((chaptermapdata) => 

                                                    <tr>
                                                        <td>{chaptermapdata.subjectName}</td>
                                                        <td>{chaptermapdata.chapter}</td>
                                                        <td>
                                                            {
                                                                chaptermapdata.questionbarray.map((topic,index) => 
                                                                    index == 0 ?
                                                                    (<span>{topic.topic_name}</span>):("")
                                                                    
                                                                )
                                                            }
                                                        </td>
                                                        <td onClick={this.OpenQuestions.bind(this,chaptermapdata)} className='cursor_pointer'>{chaptermapdata.questionbarray.length}</td>
                                                        
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                            
                                </div>

                                <Col sm={12} className='mt-4'>
                                    <ul className='list-inline question_sel_cls'>
                                        {
                                            this.state.viewType == "6Questions" ?
                                            (
                                                <>
                                                 <li className={this.state.viewType == "6Questions" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("6Questions")}>15 Mins, 6 Questions</li>
                                                 <li className="mr-4 disabledCursor disabledHoverColorCls">30 Mins, 15 Questions</li>
                                                 </>
                                            )
                                            :
                                            (
                                                <>
                                                <li  className="mr-4 disabledCursor disabledHoverColorCls" >15 Mins, 6 Questions</li>
                                                 <li className={this.state.viewType == "15Questions" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("15Questions")}>30 Mins, 15 Questions</li>
                                                 </>
                                            )
                                        }
                                        
                                            
                                    </ul>
                                </Col>
                                   {
                                       this.state.getInstituteQuestions != "" ?
                                       (
                                        <Form>
                                            <Row>
                                                <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="slectSubject">
                                                    <Form.Label className="text-uppercase font-weight-bold">Exam Type <span className='errorCls'>{this.state.validateExamType}</span></Form.Label>
                                                    <SelectBoxWithDisabledOption
                                                        stateData={this.state.qbsearchExamTypevalue}
                                                        handleChange={this.selecthandleInputChange}
                                                        name="qbsearchExamType"
                                                        options={this.state.examTypeOptions}
                                                        placeholderName={'Exam Type'}
                                                        dropdownIndicator={{ DropdownIndicator }}
                                                    />
                                                </Form.Group>
                                                    <Form.Group as={Col} xl={3} lg={3} md={3} sm={12} controlId="slectSubject">
                                                        <Form.Label className="text-uppercase font-weight-bold">Subject <span className='errorCls'>{this.state.validateSubject}</span></Form.Label>
                                                        <SelectBoxWithDisabledOption
                                                            stateData={this.state.qbsearchsubjectvalue}
                                                            handleChange={this.selecthandleInputChange}
                                                            name="qbsearchsubject"
                                                            options={this.state.subjectOptions}
                                                            placeholderName={'Subject'}
                                                            dropdownIndicator={{ DropdownIndicator }}
                                                            isOptionDisabled={option => option.isDisabled}
                                                            
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectChapters">
                                                        <Form.Label className="text-uppercase font-weight-bold">Chapter <span className='errorCls'>{this.state.validateChapter}</span></Form.Label>
                                                        <SelectBoxWithDisabledOption
                                                        stateData={this.state.qbsearchchaptervalue}
                                                            handleChange={this.selecthandleInputChange}
                                                            name="qbsearchchapter"
                                                            options={this.state.getChaptersArr}
                                                            placeholderName={'Chapters'}
                                                            dropdownIndicator={{ DropdownIndicator }}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectTopics">
                                                        <Form.Label className="text-uppercase font-weight-bold">Topic <span className='errorCls'>{this.state.validateTopic}</span></Form.Label>
                                                        <SelectBoxWithDisabledOption
                                                            stateData={this.state.qbsearchtopicvalue}
                                                            handleChange={this.selecthandleInputChange}
                                                            name="qbsearchtopic"
                                                            options={this.state.getTopicsArr}
                                                            placeholderName={'Topics'}
                                                            dropdownIndicator={{ DropdownIndicator }}
                                                        />
                                                    
                                                    </Form.Group>
            
                                                    </Row>
                                                    <Row>
                                                        <Col sm={12}>
                                                        {/*  <Button type="button" className="btn btn-light-blue float-right mt-2" onClick={(e) => this.onScrollgetQuestionById(e)}>Get Questions</Button>*/}
                                                        </Col>
                                                    </Row>
                                                    
                                            </Form>
                                       )
                                       :
                                       ("")
                                   }     
                                

                                {
                            this.state.getInstituteQuestions == "" ?
                            ( 
                                <Row>
                                    <Col sm={12} className={this.state.showSpinner == "show" ? "showSpinnerCls text-center" : "hideSpinnerCls text-center"}>
                                        <div class="spinner-border text-primary text-center loading-img-center"></div>
                                    </Col>
                                </Row>
                            )
                            :
                            ("")
                        }
                        
                        {this.state.getInstituteQuestions.length > 0 ?  (
                            <div>
                            <Row className="mt-5">
                                <Col sm={12} >
                                    <h5>
                                    {
                                       
                                        this.state.viewType == "6Questions" ?
                                        (<><span>{this.getSelectedSubject()}</span> : Questions Selected - {this.state.validateQuestionSelected.length}/6 <span className='errorCls1'>{this.state.validationMessage}</span></>)
                                        :
                                        (<><span>{this.getSelectedSubject()}</span> : Questions Selected - {this.state.validateQuestionSelected.length}/15 <span className='errorCls1'>{this.state.validationMessage}</span></>)
                                       
                                    
                                    }
                                    
                                    <span><Button type="button" className="btn btn-light-blue float-right" onClick={(e) => this.popupModalQuiz()}>Generate Quiz</Button></span>

                                    </h5>
                                    <h6 className='errorCls1'>{this.state.questionSelectedMessage}</h6>
                                    

                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <Card as={Card.Body}>
                                        <Row>
                                            <Col sm={12}>
                                                <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="quentionSearch" className='float-right'>
                                                    <Form.Control
                                                        type="text"
                                                        name="quesionsearch"
                                                        value={this.state.quesionsearch}
                                                        onChange={this.quentionSearchhandleChange}
                                                        placeholder="Question Search"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Scrollbars style={{ height: 800 }}
                                                {...this.props}
                                                renderThumbVertical={renderThumb}
                                                autoHide
                                                autoHideTimeout={800}
                                                autoHideDuration={200}>
                                                {this.state.getInstituteQuestions.length > 0 ? (
                                                    <InfiniteScroll
                                                        dataLength={this.state.getInstituteQuestions.length}
                                                        next={(e) => this.onScrollgetQuestions(e)}
                                                        hasMore={this.state.hasMore}
                                                        loader={
                                                            <p style={{ textAlign: "center", overflow: "hidden !important" }}>
                                                                <b>Loading...</b>
                                                            </p>}
                                                        endMessage={
                                                            <p style={{ textAlign: "center", overflow: "hidden !important" }}>
                                                                <b>Yay! You have seen it all</b>
                                                            </p>
                                                        }
                                                    >
                                                        {latestData.map((questionsData, index) => {
                                                                return (
                                                                        <Card as={Card.Body} className="bg-light mt-2">
                                                                            <Form.Check type="checkbox" id={"checkbox_4031" + index} custom>
                                                                            {
                                                                                questionsData.checked == true ?
                                                                                (<Form.Check.Input type="checkbox"  checked={questionsData.checked} onChange={(e) => {this.QuestionFunction(e, questionsData, "qbank");}} />)
                                                                                :
                                                                                (<Form.Check.Input type="checkbox"  checked={this.state.checkedVall} onChange={(e) => {this.QuestionFunction(e, questionsData, "qbank");}} />)
                                                                            }
                                                                                
                                                                                <Form.Check.Label htmlFor={"checkbox_4031" + index}>
                                                                                    <span>{this.idFunction(index)} .</span>
                                                                                    {parse(questionsData.question)}
                                                                                    {" QID- " + questionsData.id }
                                                                                </Form.Check.Label>
                                                                            </Form.Check>
                                                                            <hr className="my-3" />
                                                                            <Row>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>A.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option1)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>B.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option2)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>C.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option3)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>D.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option4)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span className="font-weight-bold">Currect Answer:</span>
                                                                                        <div className="font-weight-bold ml-2">{questionsData.answer}</div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>

                                                                        </Card>
                                                                    )
                                                                })}
                                                    </InfiniteScroll>) : (
                                                        <React.Fragment>
                                                            {latestData.map((questionsData, index) => {
                                                                return (
                                                                        <Card as={Card.Body} className="bg-light mt-2">
                                                                            <Form.Check type="checkbox" id={"checkbox_4031" + index} custom>
                                                                            {
                                                                                questionsData.checked == true ?
                                                                                (<Form.Check.Input type="checkbox"  checked={questionsData.checked} onChange={(e) => {this.QuestionFunction(e, questionsData, "qbank");}} />)
                                                                                :
                                                                                (<Form.Check.Input type="checkbox"  checked={this.state.checkedVall} onChange={(e) => {this.QuestionFunction(e, questionsData, "qbank");}} />)
                                                                            }
                                                                                
                                                                                <Form.Check.Label htmlFor={"checkbox_4031" + index}>
                                                                                    <span>{this.idFunction(index)} .</span>
                                                                                    {parse(questionsData.question)}
                                                                                    {" QID- " + questionsData.id }
                                                                                </Form.Check.Label>
                                                                            </Form.Check>
                                                                            <hr className="my-3" />
                                                                            <Row>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>A.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option1)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>B.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option2)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>C.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option3)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span>D.</span>
                                                                                        <div className="ml-2">{parse(questionsData.option4)}</div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span className="font-weight-bold">Currect Answer:</span>
                                                                                        <div className="font-weight-bold ml-2">{questionsData.answer}</div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>

                                                                        </Card>
                                                                    )
                                                                })}

                                                            {this.state.getInstituteQuestions.length == 0 ? (<p style={{ textAlign: "center" }}>
                                                                <b>No data available </b>
                                                            </p>) : (<p style={{ textAlign: "center" }}>
                                                                <b>Yay! You have seen it all</b>
                                                            </p>)}
                                                        </React.Fragment>
                                                    )}
                                            </Scrollbars>
                                        </Card>
                                    </Col>
                                </Row>
                                   
                                </div>
                                
                             ):("")}

                            </Card>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <QuizModal
                                stateData={this.state}
                                parentpdatefunction={this.datefunction}
                                parentpdatefunctionend={this.datefunctionend}
                                ParentsheduleFunction={this.sheduleFunction}
                                ParenthandleFormSubmit={this.handleFormSubmit}
                                show={this.state.modalShow}
                                showothermodal={() => this.setState({ modalShowTwo: true })}
                                onHide={() => this.setState({ modalShow: false, submitError1: "" })}
                                globals={this.props.globals}
                                getSections={this.state.getSectionsArr}
                                phandleInputChange={this.handleInputChange}
                                pselecthandleInputChange={this.selecthandleInputChange}
                                handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}
                            />                        
                        </Col>
                    </Row>
            </Container>                           
        </div>

        )
    }
}


export default withRouter(withApollo(
    compose(
        graphql(GROUPcreateQuizPaper, {
            name: "creategroupgeneralpaperfun"
        }),


    )
        (EditQuizSection)));

